import { render, staticRenderFns } from "./OccurrenceDetailModal.vue?vue&type=template&id=57f3992c&scoped=true&"
import script from "./OccurrenceDetailModal.vue?vue&type=script&lang=js&"
export * from "./OccurrenceDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceDetailModal.vue?vue&type=style&index=0&id=57f3992c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f3992c",
  null
  
)

export default component.exports